export default {
  DAILY: 'daily',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
  QUARTER: 'quarter',
  HALF: 'half',
  YEARLY: 'yearly'
}



// WEBPACK FOOTER //
// ./src/components/menus/ticket/enums/dateType.js